import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChildren, SimpleChanges} from '@angular/core';

import * as moment from 'moment';
import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/cpg/services/coupons.service';

@Component({
  selector: 'app-create-coupon-submit',
  templateUrl: './create-coupon-submit.component.html',
  styleUrls: ['./create-coupon-submit.component.scss']
})
export class CreateCouponSubmitComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER)
  @Output() navigation = new EventEmitter(); // Navigation click event

  public loginData: any;
  public couponData: any;

  public retailersLoading: boolean = false;
  public creatingCoupon: boolean = false;

  public calendarConfig = { adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers: false };
  public calendarMinDate: Date = new Date(moment.utc().format('YYYY-MM-DD'));

  public couponSaveConfirmModal: BsModalRef;

  constructor(
    private _modalService: BsModalService,
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if (this.module == 'CPG') {
      this.loginData = await this._utilService.getStorageData('C_LOGIN');
      this.couponData = await this._utilService.getStorageData('C_NEW_COUPON');
    } else if (this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
      this.couponData = await this._utilService.getStorageData('R_NEW_COUPON');

      // Calendar setings with timezone
      this.calendarMinDate = new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm'));

      // Get store list based on products selected
      this.retailersLoading = true;

      let retailerData: any = await this._utilService.getStorageData('R_RETAILERS');
      this.couponData.retailers = []

      // Get selected products in step 1
      let selectedProducts: any = [];
      if (this.couponData) {
        selectedProducts = this.couponData.products;
      }

      // Get retailer list
      let getRetailersBody = {
        provider_type: this.loginData.user_details.provider_type,
        provider_id: this.loginData.user_details.provider_id,
        products: selectedProducts
      };

      this._couponsService.getRetailers(this.loginData.token, getRetailersBody).subscribe(async getRetailersResponse => {
        this.retailersLoading = false;

        if (getRetailersResponse.status === true) { // Success
          if (getRetailersResponse.retailers.length > 0 ) {
            let selectedRetailerDetails : any = {
              retailer_id: getRetailersResponse.retailers[0].retailer_id,
              retailer_name: getRetailersResponse.retailers[0].retailer_name,
              logo: getRetailersResponse.retailers[0].logo,
              stores: []
            };

            for (let i=0; i  <= getRetailersResponse.retailers.length - 1; i++) {
              selectedRetailerDetails.stores.push({
                status:  true, // Select by default
                store_id:  getRetailersResponse.retailers[i].store_id,
                store_name: getRetailersResponse.retailers[i].store_name,
                date_range: [new Date(moment().utcOffset(this.loginData.user_details.user_timezone).format('YYYY-MM-DD HH:mm')), new Date(moment().utcOffset(this.loginData.user_details.user_timezone).add(30, 'days').format('YYYY-MM-DD HH:mm'))],
                max_redeem_quantity: 1, // Default
                max_redemptions: 0, // Default
              });
            }

            this.couponData.retailers.push(selectedRetailerDetails);

            let responseSetStorageDataR_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
          } else {
            this._utilService.showToast('Store details not found', '', 'error', {});
          }
        } else {
          this._utilService.showToast(getRetailersResponse.message, '', 'error', {});
        }
      }, error => { // Error from getRetailers
        this.retailersLoading = false;
      });
    }
  }

  // On store select/remove
  onStoreClick(event: any, retailer: any, store: any) {
    for (let i=0; i  <= this.couponData.retailers.length - 1; i++) {
      if (this.couponData.retailers[i].retailer_id == retailer.retailer_id) { // Selected retailer
        for (let j=0; j  <= this.couponData.retailers[i].stores.length - 1; j++) {
          if (this.couponData.retailers[i].stores[j].store_id == store.store_id) { // Selected store
            this.couponData.retailers[i].stores[j].status = event.target.checked; // Change status
          }
        }
      }
    }
  }

  // On calendar value change
  onCalendarValueChange(event: any, retailer: any, store: any) {
    // Update coupon data
    for(let i=0; i<=this.couponData.retailers.length - 1; i++) {
      if (this.couponData.retailers[i].retailer_id == retailer.retailer_id) { // Selected retailer
        for(let j=0; j<=this.couponData.retailers[i].stores.length - 1; j++) {
          if (this.couponData.retailers[i].stores[j].store_id == store.store_id) { // Selected store
            this.couponData.retailers[i].stores[j].date_range = event;
            break;
          }
        }
      }
    }
  }

  // On navigation click
  async onNavigationClick(action: string, template: TemplateRef<any>) {
    if (action == 'previous') {
      // Save coupon data in storage
      if (this.module == 'CPG') {
        let responseSetStorageDataC_NEW_COUPON = await this._utilService.setStorageData('C_NEW_COUPON', this.couponData);
        this.navigation.emit({ step: 4, button: action, status : true });
      } else if (this.module == 'RETAILER') {
        let responseSetStorageDataR_NEW_COUPON = await this._utilService.setStorageData('R_NEW_COUPON', this.couponData);
        this.navigation.emit({ step: 3, button: action, status : true });
      }
    } else if (action == 'submit') {
      // Validations
      let retailer_list: any = [];
      for(let i=0; i<=this.couponData.retailers.length - 1; i++) {
        for(let j=0; j<=this.couponData.retailers[i].stores.length - 1; j++) {
          // Check if start and end dates are added for all selected stores
          if(this.couponData.retailers[i].stores[j].status == true && !this.couponData.retailers[i].stores[j].date_range) {
            this._utilService.showToast('Please enter coupon date range for ' + this.couponData.retailers[i].retailer_name + ' - ' + this.couponData.retailers[i].stores[j].store_name, '', 'warning', {});
            return false;
          }

          // Check if qty per transaction
          if(this.couponData.retailers[i].stores[j].status == true && (this.couponData.retailers[i].stores[j].max_redeem_quantity == null)) {
            this._utilService.showToast('Please enter quantity per transaction for ' + this.couponData.retailers[i].retailer_name + ' - ' + this.couponData.retailers[i].stores[j].store_name, '', 'warning', {});
            return false;
          } else if (this.couponData.retailers[i].stores[j].max_redeem_quantity < 0) {
            this._utilService.showToast('Invalid quantity per transaction data for ' + this.couponData.retailers[i].retailer_name + ' - ' + this.couponData.retailers[i].stores[j].store_name, ' ', 'warning', {});
            return false;
          }

          // Check max redemptions
          if(this.couponData.retailers[i].stores[j].status == true && (this.couponData.retailers[i].stores[j].max_redemptions == null)) {
            this._utilService.showToast('Please enter max redemptions for ' + this.couponData.retailers[i].retailer_name + ' - ' + this.couponData.retailers[i].stores[j].store_name, '', 'warning', {});
            return false;
          } else if (this.couponData.retailers[i].stores[j].max_redemptions < 0) {
            this._utilService.showToast('Invalid max redemptions data for ' + this.couponData.retailers[i].retailer_name + ' - ' + this.couponData.retailers[i].stores[j].store_name, ' ', 'warning', {});
            return false;
          }

          // Add selected stores
          if(this.couponData.retailers[i].stores[j].status == true) {
            retailer_list.push({
              retailer_id: this.couponData.retailers[i].retailer_id,
              store_id: this.couponData.retailers[i].stores[j].store_id
            })
          }
        }
      }

      // Check if atleast one store is selected
      if (retailer_list.length == 0) {
        this._utilService.showToast('Please select store', '', 'warning', {});
        return false;
      }

      this.couponSaveConfirmModal = this._modalService.show(template, {class: 'modal-sm', ignoreBackdropClick: true});
    }
  }

  // Create coupon
  createCoupon() {
    // Get retailer store details
    let retailer_list: any = [];
    for(let i=0; i<=this.couponData.retailers.length - 1; i++) {
      for(let j=0; j<=this.couponData.retailers[i].stores.length - 1; j++) {
        // Add selected stores
        if(this.couponData.retailers[i].stores[j].status == true) {
          retailer_list.push({
            retailer_id: this.couponData.retailers[i].retailer_id,
            store_id: this.couponData.retailers[i].stores[j].store_id,
            start_date: moment(this.couponData.retailers[i].stores[j].date_range[0]).format('YYYY-MM-DD') + ' 00:00:00.000', // 12 AM
            end_date: moment(this.couponData.retailers[i].stores[j].date_range[1]).format('YYYY-MM-DD') + ' 23:59:59.000', // 11:59 PM
            max_redeem_quantity: this.couponData.retailers[i].stores[j].max_redeem_quantity,
            max_redemptions: this.couponData.retailers[i].stores[j].max_redemptions
          })
        }
      }
    }

    // Check if atleast one store is selected
    if (retailer_list.length > 0) {
      let createCouponsBody: any = {
        provider_type: this.loginData.user_details.provider_type,
        provider_id: this.loginData.user_details.provider_id,
        products: this.couponData.products,
        categories: this.couponData.details.categories,
        mfg_id: this.couponData.details.manufacturer.mfg_id,
        brand_id: this.couponData.details.brand.brand_id,
        discount: {
          discount_id: this.couponData.details.discount_type_id,
          discount_value_lower: this.couponData.details.discount_value_lower,
          discount_value_upper: this.couponData.details.discount_value_upper,
          dollar_discount_compare: this.couponData.details.dollar_discount_compare
        },
        retailers: retailer_list,
        image_path: this.couponData.details.uploadedImage,
        terms: this.couponData.details.description,
        coupon_title: this.couponData.details.title
      }

      this.creatingCoupon = true;
      
      this._couponsService.createCoupons(this.loginData.token, createCouponsBody).subscribe(async createCouponsResponse => {
        this.creatingCoupon = false;

        if (createCouponsResponse.status === true) { // Success
          this.hideCouponSaveConfirmModal(); // Close modal

          if (this.module == 'CPG') {
            this.navigation.emit({ step: 4, button: 'submit', status : true });
          } else if (this.module == 'RETAILER') {
            this.navigation.emit({ step: 3, button: 'submit', status : true });
          }
        } else {
          this._utilService.showToast(createCouponsResponse.message, '', 'error', {});
        }
      }, error => { // Error from createCoupons
        this.creatingCoupon = false;
      });
    }
  }

  // Hide coupon save confirm modal
  hideCouponSaveConfirmModal(): void {
    this.couponSaveConfirmModal.hide();
  }

}
